/* eslint-disable react/jsx-no-bind */
import React from 'react';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../res/translations/messages';
import TrackerFilterButton from './TrackerFilterButton';
import {TRACKER_FILTERS} from '../../../constants';

const TrackerFilters = ({status, initialFilterText = '', initialSortingValue = '', onChange, onApplyFilters}) => {
    const sortOptions = [
        {value: 'mobile:asc', label: messages.trackers.sorting.mobileAsc},
        {value: 'mobile:desc', label: messages.trackers.sorting.mobileDesc},
        {value: 'email:asc', label: messages.trackers.sorting.emailAsc},
        {value: 'email:desc', label: messages.trackers.sorting.emailDesc},
    ];
    const [filterText, setFilterText] = React.useState(initialFilterText);
    const [sorting, setSorting] = React.useState(initialSortingValue);
    const handleSubmit = () => {
        onApplyFilters(filterText, sorting);
    };
    const handleFilterChange = (e) => {
        const value = e && e.target ? e.target.value : e;
        setFilterText(value);
    };
    const handleSortChange = (e) => {
        const value = e && e.target ? e.target.value : e;
        setSorting(value);
    };
    const handleClear = () => {
        setFilterText('');
        setSorting('');
        onApplyFilters('', '');
    };
    return (
        <div className="row mb-3 align-items-center">
            <div className="col-auto">

                <div className="btn-group">
                    <TrackerFilterButton active={status === TRACKER_FILTERS.ALL} value={TRACKER_FILTERS.ALL} onClick={onChange}>
                        <FormattedMessage {...messages.trackers.filters.all} />
                    </TrackerFilterButton>
                    <TrackerFilterButton active={status === TRACKER_FILTERS.NOT_STARTED} value={TRACKER_FILTERS.NOT_STARTED} onClick={onChange}>
                        <FormattedMessage {...messages.trackers.filters.notStarted} />
                    </TrackerFilterButton>
                    <TrackerFilterButton active={status === TRACKER_FILTERS.NOT_COMPLETED} value={TRACKER_FILTERS.NOT_COMPLETED} onClick={onChange}>
                        <FormattedMessage {...messages.trackers.filters.notCompleted} />
                    </TrackerFilterButton>
                </div>
            </div>
            <div className="col-auto min-width-200">
                <FormattedMessage {...messages.trackers.filters.search_placeholder} >
                    {(placeholder) => <input
                        id="tracker-search"
                        type="text"
                        className="form-control"
                        placeholder={placeholder}
                        value={filterText}
                        onChange={handleFilterChange}
                    />}
                </FormattedMessage>
            </div>
            <div className="col-auto">
                <select className="form-control" value={sorting} onChange={handleSortChange}>
                    <FormattedMessage {...messages.trackers.sorting.sortPlaceholder} >
                        {(txt) => <option value="">{txt}</option>}
                    </FormattedMessage>
                    {sortOptions && sortOptions.map((opt) => (
                        <FormattedMessage key={opt.value} {...opt.label}>
                            {(txt) => <option value={opt.value}>{txt}</option>}
                        </FormattedMessage>
                    ))}
                </select>
            </div>
            <div className="col-auto">
                <button type="button" className="btn btn-primary mr-2 mb-1" onClick={handleSubmit}>
                    <FormattedMessage {...messages.trackers.filters.apply} />
                </button>
                {(filterText || sorting) && (
                    <button type="button" className="btn btn-link mb-1" onClick={handleClear}>
                        <FormattedMessage {...messages.trackers.filters.clear} />
                    </button>
                )}
            </div>
        </div>
    );
};

export default TrackerFilters;
